import { LOCALE_ID, Pipe, type PipeTransform, inject } from '@angular/core';
import { formatNumber } from '@angular/common';

@Pipe({ name: 'rtp', standalone: true, pure: true })
export class RtpFormat implements PipeTransform {
  private readonly locale = inject(LOCALE_ID);


  transform(rtp: number | null): string {
    if (rtp == null) {
      return 'n/a';
    }

    return formatNumber(rtp * 100, this.locale, '1.2-2') + ' %';
  }
}
